import { CompanyUser } from "@models/user";
import {
  WithLoggedInAuthInfoProps,
  withRequiredAuthInfo,
} from "@propelauth/react";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { fetchWithToken } from "../../api/apiBase";
import { Button } from "../ui/button";
import BaseLoadingSpinner from "../ui/baseLoadingSpinner";

/**
 *
 * */
function UserProfile(props: WithLoggedInAuthInfoProps) {
  const navigate = useNavigate();
  const [error, setError] = useState<any>(null);
  const [userData, setUserData] = useState<CompanyUser | null>(null);
  const { user } = useParams<string>();

  useEffect(() => {
    if (user) {
      fetchWithToken(`/user/profile/${user}`, props.accessToken)
        .then((data) => {
          console.log("data", data);
          setUserData(data);
        })
        .catch((error) => {
          console.log("error", error);
          setError(error);
        });
    } else {
      // getOwnProfile( props.accessToken)
      // .then((data) => {
      //         console.log('data', data)
      //         setUserData(data)
      //     }).catch((error) => {
      //     console.log('error', error)
      //     setError(error)
      // })
    }
  }, [user, props.accessToken]);

  if (userData) {
    return (
      <div className="p-4 bg-white rounded shadow-md max-w-6xl mx-auto">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-bold">User Profile</h3>
          <Button onClick={() => navigate(-1)} type="button" variant="outline">
            Back
          </Button>
        </div>
        <div className="grid grid-cols-2 gap-4 mt-10">
            <div className="flex flex-col">
              <p className="font-medium">Company</p>
              <Link to={`/company-profile/${userData}`} className="text-gray-700 hover:underline">
                {userData?.company.name}
              </Link>
            </div>
            <div>
              <p className="font-medium">Email</p>
              <p className="text-gray-700">{userData?.user.email || 'N/A'}</p>
            </div>

            <div>
              <p className="font-medium">Name</p> 
              <p className="text-gray-700">{userData?.user.name || 'N/A'}</p>
            </div>
            <div>
              <p className="font-medium">Username</p> 
              <p className="text-gray-700">{userData?.user.username || 'N/A'}</p>
            </div>

            <div>
              <p className="font-medium">Title</p> 
              <p className="text-gray-700">{userData?.user.title || 'N/A'}</p>
            </div>
            <div>
              <p className="font-medium">Phone</p> 
              <p className="text-gray-700">{userData?.user.phone || 'N/A'}</p>
            </div>
          {/*TODO to be tagged*/}
            <div>
              <p className="font-medium">Expirience</p>
            </div>
            <div>
              <p className="font-medium">Markets</p> 
              <p className="text-gray-700">{userData?.user.markets || 'N/A'}</p>
            </div>
            <div>
              <p className="font-medium">Construction Types</p>{" "}
              <p className="text-gray-700">{userData?.user.construction_types || 'N/A'}</p>
            </div>
            <div>
              <p className="font-medium">Regions</p> 
              <p className="text-gray-700">{userData?.user.regions || 'N/A'}</p>
            </div>
            <div className="col-span-2 mt-10">
            <p className="font-medium">Description</p> 
            <p className="text-gray-700">{userData?.user.description || 'N/A'}</p>
          </div>
        </div>
      </div>
    );
  } else if (error) {
    return <div>Error: {error.message}</div>;
  } else {
    return <div><BaseLoadingSpinner/></div>;
  }
}

export default withRequiredAuthInfo(UserProfile);
